export default {"src":"/_next/static/media/ultimate-frisbee.8ab756c0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};